import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'backslash'
})
export class BackslashPipe implements PipeTransform {

  transform(value: string, ...args: unknown[]): string {
    return value.replace('', '\\');
  }

}
